import { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const DEFAULT_TIMEZONE = "Asia/Kolkata";
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["SUNDAY"] = 0] = "SUNDAY";
    DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
    DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
    DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
    DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
    DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
})(DayOfWeek || (DayOfWeek = {}));
const formatDateRange = (start, end) => {
    return `${dayjs(start).format("YYYY-MM-DD HH:mm:ss")}|${dayjs(end).format("YYYY-MM-DD HH:mm:ss")}`;
};
const getTimestampForWeekday = (date, dayOfWeek, isStartTimestamp) => {
    const daysDifference = (date.day() - dayOfWeek + 7) % 7;
    const lastDayOfWeek = date.subtract(daysDifference, "day");
    let timestamp = lastDayOfWeek.startOf("day");
    if (!isStartTimestamp) {
        timestamp = lastDayOfWeek.endOf("day");
    }
    return timestamp.format("YYYY-MM-DD HH:mm:ss");
};
const getBillingCycle = (date) => {
    const dayOfWeek = date.day();
    switch (dayOfWeek) {
        case DayOfWeek.SATURDAY:
        case DayOfWeek.SUNDAY:
        case DayOfWeek.MONDAY:
            return {
                startTimestamp: getTimestampForWeekday(date, DayOfWeek.SATURDAY, true),
                endTimestamp: getTimestampForWeekday(date, DayOfWeek.MONDAY, false),
            };
        case DayOfWeek.TUESDAY:
        case DayOfWeek.WEDNESDAY:
        case DayOfWeek.THURSDAY:
        case DayOfWeek.FRIDAY:
            return {
                startTimestamp: getTimestampForWeekday(date, DayOfWeek.TUESDAY, true),
                endTimestamp: getTimestampForWeekday(date, DayOfWeek.FRIDAY, false),
            };
        default:
            throw new Error(`No billing cycle found for the current day ${date.format("dddd")}`);
    }
};
const generateLast10BillingCycles = () => {
    const billingCycles = [];
    const minDate = dayjs("2024-12-24").tz(DEFAULT_TIMEZONE);
    let currentCycle = getBillingCycle(dayjs().tz(DEFAULT_TIMEZONE));
    billingCycles.push(currentCycle);
    while (billingCycles.length < 10) {
        const nextCycleStart = dayjs(currentCycle.startTimestamp).subtract(1, "day");
        currentCycle = getBillingCycle(nextCycleStart);
        billingCycles.push(currentCycle);
        if (dayjs(currentCycle.startTimestamp).isBefore(minDate)) {
            break;
        }
    }
    return billingCycles;
};
export const useBillingCycles = () => {
    return useMemo(() => {
        return generateLast10BillingCycles().map((cycle) => formatDateRange(cycle.startTimestamp, cycle.endTimestamp));
    }, []);
};
